// Paints the Oct 30 and Oct 31 rows orange.
// The Seated widget renders its table asynchronously and re-renders on its own,
// so the pass runs once and then again on every mutation inside the widget host.
const WIDGET_ID = 'seated-55fdf2c0'

const markSpookyRows = () => {
  ;[...document.getElementsByClassName('seated-event-date-cell')].forEach((cell) => {
    const date = cell.textContent?.trim() || ''
    if (date.includes('Oct 30') || date.includes('Oct 31')) {
      cell.parentElement?.parentElement?.classList.add('spooky')
    }
  })
}

markSpookyRows()

const widget = document.getElementById(WIDGET_ID)
const observer = new MutationObserver(() => {
  markSpookyRows()
})

if (widget) {
  observer.observe(widget, { childList: true, subtree: true })
}
